import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, Subject, of} from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class ComponentsService {
  private subject = new Subject<any>();
  // Dedicated subject for Evi-related commands (expand, minimize, open, close, etc.)
  private _eviCommand = new Subject<string>();
  private mini_form_question = new Subject<any>();
  private discount_flow = new Subject<any>();
  constructor(private http: HttpClient) {}

  reloadComponent(reload: boolean): void {
    this.subject.next({reload});
  }

  sendSecurityCode(code: string): void {
    this.subject.next({code});
  }
 
  getSecurityCode(): Observable<any> {
    return this.subject.asObservable();
  }

  getReloadRequest(): Observable<any> {
    return this.subject.asObservable();
  }
  setMiniFormQuestion (questions: any) : void {
    this.mini_form_question.next(questions);
  }
  getMiniFormQuestion () :  Observable<any>  {
    return this.mini_form_question.asObservable()
  }
  setDiscountFlow(flow: any): void {
    this.discount_flow.next(flow);
  }
  setTermsAccepted(terms: boolean): void {
    this.subject.next({terms});
  }
  getTermsAccepted(): Observable<any>  {
    return this.subject.asObservable();
  }
  getDiscountFlow() : Observable<any> {
    return this.discount_flow.asObservable();
  }
  /**
   * Send a command intended for the Evi component.
   * Example: sendEviCommand('expand')
   */
  sendEviCommand(cmd: string): void {
    this._eviCommand.next(cmd);
  }

  getEviCommands(): Observable<string> {
    return this._eviCommand.asObservable();
  }
  fetchFile(fileUrl: string): Observable<Blob> {
    return this.http.get(fileUrl, { responseType: 'blob' }).pipe(
      catchError(error => {
        console.error('Error fetching file:', error);
        return of(new Blob()); // Return empty Blob on error
      })
    );
  }

  // Upload file to a POST URL
  uploadFile(file: Blob, uploadUrl: string): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, 'downloaded-file'); // Specify a default name

    return this.http.post(uploadUrl, formData, {
      reportProgress: true,
      observe: 'events',
    });
  }
  
}

